<div class="initial-wrapper bold">{{ firstLetter }}{{ secondLetter }}</div>
